import {
   CurrentProviderEzwmConfigurationQuery,
   CurrentProviderEzwmConfigurationSetCommand,
} from '@dreryk/egabinet-ezwm-frontend-api';

import { refetchCqrsQuery, useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { Button, ButtonVariant } from '@dreryk/react-components';

import { nfzSettingsTranslationKeys } from '../../../../translations';
import { dispatchConfigurationSavePositiveSnackbar } from '../NfzSettingsSaveAction.hooks';

import { EzwmSenderCodeFormBean, EzwmSenderCodeFormController } from './EzwmSenderCode.types';

type EzwmSenderCodeSaveButtonProps = {
   readonly handleSubmit: EzwmSenderCodeFormController['handleSubmit'];
};

const useCurrentHealthcareProviderEzwmConfigurationSetCommand = (): UseCqrsCommandResult<
   void,
   EzwmSenderCodeFormBean
> => {
   return useCqrsCommand(
      (parameters) => {
         const command = new CurrentProviderEzwmConfigurationSetCommand();
         command.senderCode = parameters.senderCode;
         return command;
      },
      {
         onSuccess: () => {
            refetchCqrsQuery(CurrentProviderEzwmConfigurationQuery);
            dispatchConfigurationSavePositiveSnackbar(nfzSettingsTranslationKeys.ezwmConfigurationWasSaved);
         },
      }
   );
};

export const EzwmSenderCodeSaveButton = (props: EzwmSenderCodeSaveButtonProps): JSX.Element => {
   const { executeAsync: saveEzwmSenderCode } = useCurrentHealthcareProviderEzwmConfigurationSetCommand();
   return (
      <Button
         testId={'saveEzwmSenderCode'}
         onClick={props.handleSubmit(saveEzwmSenderCode)}
         label={nfzSettingsTranslationKeys.save}
         variant={ButtonVariant.PRIMARY}
      />
   );
};
